<template>
    <div class="regular-filter">
        <base-dropdown horizontalPosition="auto"
            ref="dropdownRef"
            @dropdownClosed="handleDropdownClose">
            <template v-slot:trigger>
                <filter-button class="regular-filter__button"
                    :label="label"
                    :number="number"
                    :active="!!number" />
            </template>
            <new-multi-select-dropdown class="regular-filter__dropdown" 
                :search-placeholder="searchPlaceholder"
                :list-title="listTitle"
                :options="options"
                :values="innerValues"
                @selection-changed="handleSelectionUpdate"
                @selection-applied="handleSelectionApply" />
        </base-dropdown>
            
    </div>
</template>

<script>
import FilterButton from './FilterButton.vue';
export default {
    name: 'RegularFilter',
    emits: ['change'],
    components: { FilterButton },
    props: {
        type: String,
        label: String,
        searchPlaceholder: String,
        listTitle: String,
        options: {
            type: Array,
            default: () => []
        },
        values: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            innerValues: [...this.values],
            number: this.values.length,
        }
    },
    watch: {
        values: {
            handler() {
                this.innerValues = [...this.values];
            },
            deep: true
        }
    },
    methods: {
        handleSelectionUpdate(selection) {
            this.number = selection.length;
        },
        handleSelectionApply(selection) {
            const filters = selection.map(value => ({
                text: this.options.find(option => option.value === value)?.label || '',
                value
            }))
            this.$emit('change', filters);
            this.$refs.dropdownRef.close();
        },
        handleDropdownClose() {
            this.number = this.values.length
        }
    }
}
</script>

<style lang="scss" scoped>
.regular-filter {
    position: relative;

    &__dropdown {
        max-height: 350px;
    }

    &__input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    // &::v-deep .smart-select {
    //     height: 40px !important;

    //     &__header {
    //         opacity: 0 !important;
    //         cursor: pointer;
    //     }

    //     &__list {
    //         margin-top: 8px;
    //     }
    // }
}
</style>